import {Store} from "../../../stem-core/src/state/Store";
import {MerchantSettingsVersionStore} from "../merchant/MerchantSettingsVersionStore";

/* TODO: Remove this in the future.
    this is required because the ws server does not guarantee the order of
    subscription status updates - ACTIVE status may be received before
    PENDING
*/
export const PaymentStatusDependentStore = (...args) =>
    class PaymestStatusStore extends Store(...args) {
        importState(objects) {
            objects = objects || [];
            for (const obj of objects) {
                const subscription = this.get(obj.id);
                if (!this.shouldSkipUpdate(subscription, obj)) {
                    super.importState([obj]);
                }
            }
        }

        applyEvent(event) {
            const obj = this.getObjectForEvent(event);

            if (this.shouldSkipUpdate(obj, event.data)) {
                event.data = obj;
            }
            return super.applyEvent(event);
        }

        shouldSkipUpdate(obj, updateObj) {
            return !updateObj;
        }
    };


export function loadVersionedObjectFromResponse(store, response, expectedVersionParentId) {
    const objects = store.loadFromResponse(response);
    if (objects.length <= 1) {
        return objects[0];
    }
    // We forked the published version of merchant settings with this request
    const settingsVersion = MerchantSettingsVersionStore.loadObjectFromResponse(response);
    // Find the object that is part of the forked settings and has the expected
    // version parent.
    return objects.find(obj => obj.settingsVersion === settingsVersion && obj.versionParentId == expectedVersionParentId);
}
